export default "__VITE_ASSET__0ddfe326__"